/* DYSTOPYE — thème Shopify */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var D = window.DYSTO || { routes: {}, strings: {} };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  var money = function (c) { var a = (c / 100).toFixed(2); var f = D.moneyFormat || 'CHF {{amount}}'; return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(c / 100)).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, a.replace('.', ',')).replace(/\{\{\s*amount\s*\}\}/, a).replace(/<[^>]+>/g, ''); };
  var lock = function (on) { document.body.style.overflow = on ? 'hidden' : ''; };

  /* ---------- toast ---------- */
  var tto;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.querySelector('span').innerHTML = msg; t.classList.add('on');
    clearTimeout(tto); tto = setTimeout(function () { t.classList.remove('on'); }, 2800);
  }
  document.addEventListener('click', function (e) { if (e.target.closest('#toast')) openCart(); });

  /* ---------- menu / recherche ---------- */
  function menu(o) { var m = $('#menu'); if (!m) return; m.classList.toggle('on', !!o); m.setAttribute('aria-hidden', !o); lock(o); }
  function search(o) {
    var s = $('#srch'); if (!s) return; s.classList.toggle('on', !!o); s.setAttribute('aria-hidden', !o);
    if (o) setTimeout(function () { $('#sq').focus(); }, 300);
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-menu-open]')) { e.preventDefault(); menu(1); }
    if (e.target.closest('[data-menu-close]')) { menu(0); }
    if (e.target.closest('#menu a')) { menu(0); }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); search(1); }
    if (e.target.closest('[data-search-close]')) { search(0); }
  });
  var sTimer;
  var sq = $('#sq');
  if (sq) sq.addEventListener('input', function () {
    clearTimeout(sTimer);
    var q = sq.value.trim();
    sTimer = setTimeout(function () {
      var res = $('#sres'); if (!q) { res.innerHTML = ''; return; }
      fetch((D.routes.search || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          res.innerHTML = ps.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
            return '<a href="' + p.url + '"><div class="th">' + (img ? '<img src="' + img + '" alt="">' : '') + '</div><b>' + p.title + '</b><span class="mono">' + (p.price ? p.price : '') + '</span></a>';
          }).join('') || '<p class="mono" style="color:var(--mute)">—</p>';
        }).catch(function () {});
    }, 220);
  });

  /* ---------- panier (AJAX + Section Rendering) ---------- */
  function openCart() { var c = $('#cartd'); if (!c) { location.href = D.routes.cart || '/cart'; return; } c.classList.add('on'); $('#ov').classList.add('on'); }
  function closeCart() { var c = $('#cartd'); if (c) c.classList.remove('on'); var o = $('#ov'); if (o) o.classList.remove('on'); }
  function renderDrawer(html) {
    if (!html) return;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cartd'); var cur = $('#cartd');
    if (fresh && cur) { var wasOpen = cur.classList.contains('on'); cur.replaceWith(fresh); if (wasOpen) fresh.classList.add('on'); }
    var cnt = fresh ? fresh.getAttribute('data-count') : null; if (cnt !== null && $('#cc')) $('#cc').textContent = cnt;
  }
  function addToCart(id, qty, title, open) {
    return fetch((D.routes.cart_add || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }], sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status) { toast(d.description || d.message); return; }
      renderDrawer(d.sections && d.sections['cart-drawer']);
      var it = d.items && d.items[0];
      toast((it ? it.product_title + (it.variant_title ? ' — ' + it.variant_title : '') : (title || '')) + ' ' + (D.strings.added || ''));
      if (open) openCart();
    });
  }
  function changeLine(line, qty) {
    fetch((D.routes.cart_change || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty), sections: 'cart-drawer' })
    }).then(function (r) { return r.json(); }).then(function (d) { renderDrawer(d.sections && d.sections['cart-drawer']); });
  }
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open && $('#cartd')) { e.preventDefault(); menu(0); openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.id === 'ov') { closeCart(); return; }
    var q = e.target.closest('#cartd [data-qty]');
    if (q) { e.preventDefault(); changeLine(q.getAttribute('data-qty'), q.getAttribute('data-to')); return; }
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); e.stopPropagation(); if (add.disabled) return; add.classList.add('busy'); addToCart(add.getAttribute('data-add'), 1).finally(function () { add.classList.remove('busy'); }); return; }
    if (e.target.closest('[data-noclick]')) { e.preventDefault(); }
  }, true);

  /* ---------- lightbox ---------- */
  document.addEventListener('click', function (e) {
    var z = e.target.closest('[data-zoom]');
    if (z) { var lb = $('#lb'); if (!lb) return; lb.querySelector('img').src = z.currentSrc || z.src; lb.classList.add('on'); }
    else if (e.target.closest('#lb')) $('#lb').classList.remove('on');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { menu(0); search(0); closeCart(); popup(0); var lb = $('#lb'); if (lb) lb.classList.remove('on'); }
  });

  /* ---------- fiche produit ---------- */
  $$('[data-product]').forEach(function (root) {
    var car = $('[data-car]', root);
    if (car) {
      var n = car.children.length;
      var slideTo = function (i) { car.scrollTo({ left: i * car.clientWidth, behavior: 'smooth' }); };
      var cur = function () { return Math.round(car.scrollLeft / car.clientWidth); };
      $$('[data-slide]', root).forEach(function (b) { b.addEventListener('click', function () { slideTo((cur() + Number(b.getAttribute('data-slide')) + n) % n); }); });
      $$('.thumbs [data-to]', root).forEach(function (b) { b.addEventListener('click', function () { slideTo(Number(b.getAttribute('data-to'))); }); });
      car.addEventListener('scroll', function () {
        var i = cur(); var c = $('[data-count]', root);
        if (c) c.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
        $$('.thumbs button', root).forEach(function (b, j) { b.classList.toggle('on', j === i); });
        $$('.dots i', root).forEach(function (b, j) { b.classList.toggle('on', j === i); });
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if ($('#lb.on') || /INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName)) return;
        if (e.key === 'ArrowRight') slideTo((cur() + 1) % n);
        if (e.key === 'ArrowLeft') slideTo((cur() - 1 + n) % n);
      });
    }
    var form = $('[data-product-form]', root);
    if (!form) return;
    var variants = []; try { variants = JSON.parse($('[data-variants]', root).textContent); } catch (e) {}
    var chosen = [];
    var single = variants.length === 1;
    var idInput = $('[data-variant-id]', form);
    var btn = $('[data-add-btn]', form);
    var pickVariant = function () {
      var v = variants.find(function (v) { return v.options.every(function (o, i) { return chosen[i] === o; }); });
      return v;
    };
    $$('[data-opt]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var oi = Number(b.getAttribute('data-opt'));
        $$('[data-opt="' + oi + '"]', form).forEach(function (x) { x.classList.toggle('on', x === b); });
        chosen[oi] = b.getAttribute('data-val');
        var lbl = $$('[data-sel-label]', form)[oi]; if (lbl) { lbl.textContent = chosen[oi]; lbl.style.color = ''; }
        var v = pickVariant();
        if (v) {
          idInput.value = v.id;
          var bp = $('[data-btn-price]', form); if (bp) bp.textContent = money(v.price);
          if (v.featured_media && car) { var idx = $$('.g', car).findIndex(function (g) { return g.getAttribute('data-media-id') == v.featured_media.id; }); if (idx > 0) car.scrollTo({ left: idx * car.clientWidth, behavior: 'smooth' }); }
          try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
        }
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var needs = btn.getAttribute('data-need-choice') === 'true' && !single;
      var nOpts = $$('[data-sel-label]', form).length;
      if (needs && chosen.filter(Boolean).length < nOpts) {
        toast(D.strings.chooseSize || 'Choisis ta taille');
        $$('[data-sel-label]', form).forEach(function (l, i) { if (!chosen[i]) l.style.color = 'var(--r)'; });
        btn.classList.remove('shake'); void btn.offsetWidth; btn.classList.add('shake'); return;
      }
      btn.disabled = true;
      addToCart(idInput.value, 1, null, true).finally(function () { btn.disabled = false; });
    });
  });

  /* ---------- collection : grille / index, aperçu, tri ---------- */
  $$('[data-shop]').forEach(function (root) {
    var set = function (v) { root.classList.toggle('idx', v === 'idx'); $$('.vw [data-v]', root).forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-v') === v); }); store.set('dysto_view', v); };
    $$('.vw [data-v]', root).forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-v')); }); });
    if (store.get('dysto_view') === 'idx') set('idx');
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); location.href = u; });
    var pk = $('#peek'), idx = $('.index', root);
    if (pk && idx && matchMedia('(hover:hover)').matches) {
      idx.addEventListener('mousemove', function (e) {
        var r = e.target.closest('.row'); if (!r || !r.getAttribute('data-peek')) { pk.classList.remove('on'); return; }
        var img = pk.querySelector('img'); var src = r.getAttribute('data-peek'); if (img.getAttribute('src') !== src) img.src = src;
        pk.style.left = (e.clientX + 190) + 'px'; pk.style.top = e.clientY + 'px'; pk.classList.add('on');
      });
      idx.addEventListener('mouseleave', function () { pk.classList.remove('on'); });
    }
  });

  /* ---------- manifeste ---------- */
  $$('[data-manif] .big').forEach(function (p) {
    var map = {}; try { map = JSON.parse(p.getAttribute('data-words') || '{}'); } catch (e) {}
    var norm = function (w) { return w.replace(/[.,;:!?«»"]/g, '').toLowerCase(); };
    var keys = {}; Object.keys(map).forEach(function (k) { keys[norm(k)] = map[k]; });
    p.innerHTML = p.textContent.trim().split(/\s+/).map(function (w) {
      var c = keys[norm(w)];
      return '<span' + (c ? ' data-c="' + c + '"' : '') + '>' + w + '</span>';
    }).join(' ');
  });

  /* ---------- pop-up newsletter ---------- */
  function popup(o) {
    var p = $('#pop'); if (!p) return;
    p.classList.toggle('on', !!o);
    if (!o && p.getAttribute('data-test') !== 'true') store.set('dysto_pop', String(Date.now() + Number(p.getAttribute('data-days') || 14) * 864e5));
  }
  (function () {
    var p = $('#pop'); if (!p) return;
    if ($('[data-pop-success]', p)) { popup(1); setTimeout(function () { popup(0); }, 2600); return; }
    var until = Number(store.get('dysto_pop') || 0);
    var test = p.getAttribute('data-test') === 'true';
    if (!test && until > Date.now()) return;
    if (window.Shopify && Shopify.designMode) return;
    setTimeout(function () { popup(1); }, Number(p.getAttribute('data-delay') || 7) * 1000);
    p.addEventListener('click', function (e) { if (e.target === p || e.target.closest('[data-pop-close]')) popup(0); });
  })();
  document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector('#pop')) popup(1); });
  document.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector('#pop')) $('#pop').classList.remove('on'); });

  /* ---------- apparition au défilement ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('on'); io.unobserve(x.target); } });
  }, { threshold: .12 }) : null;
  $$('.rv,.mk').forEach(function (el) { io ? io.observe(el) : el.classList.add('on'); });

  /* ---------- horloge ---------- */
  var clocks = $$('[data-clock]');
  if (clocks.length) { var tick = function () { var d = new Date(); clocks.forEach(function (c) { c.textContent = d.toLocaleDateString() + ' — ' + d.toLocaleTimeString(); }); }; tick(); setInterval(tick, 1000); }

  /* ---------- défilement : ouverture logo-fenêtre, en-tête, parallax ---------- */
  var hdr = $('#hdr');
  var intro = $('[data-intro]');
  var byhero = $('[data-parallax-hero]');
  var manif = $('[data-manif] .big');
  function frame() {
    var vh = innerHeight, y = scrollY;
    if (intro) {
      var max = intro.offsetHeight - vh, top = intro.offsetTop;
      var p = Math.min(1, Math.max(0, (y - top) / max)), e = Math.pow(p, innerWidth < 700 ? 1.7 : 2.4), base = innerWidth < 700 ? 82 : 86;
      var veil = $('.veil', intro), ph = $('.ph', intro);
      window.veilT && window.veilT(intro, base, e);
      veil.style.opacity = p < .45 ? 1 : Math.max(0, 1 - (p - .45) / .3);
      if (ph) ph.style.transform = 'scale(' + (1.25 - .25 * Math.min(1, p * 1.3)) + ')';
      $('.shade', intro).style.opacity = Math.min(1, Math.max(0, (p - .5) / .3));
      $('.hint', intro).style.opacity = p > .05 ? 0 : 1;
      $('.reveal', intro).classList.toggle('on', p > .82);
      var hud = $('.hud', intro); if (hud) hud.classList.toggle('on', p > .75);
      if (hdr && hdr.classList.contains('can-over')) hdr.classList.toggle('over', y < top + intro.offsetHeight - 80);
    } else if (byhero) {
      var bh = byhero.offsetHeight;
      if (hdr && hdr.classList.contains('can-over')) hdr.classList.toggle('over', y < bh - 80);
      var bi = $('img', byhero); if (bi && y < bh) bi.style.transform = 'translateY(' + (y * .18) + 'px)';
    }
    if (manif) {
      var r = manif.getBoundingClientRect();
      var k = Math.min(1, Math.max(0, (vh * .85 - r.top) / (r.height + vh * .35)));
      var sp = manif.querySelectorAll('span'), n = Math.round(k * sp.length);
      for (var i = 0; i < sp.length; i++) { var lit = i < n; sp[i].classList.toggle('lit', lit); var c = sp[i].getAttribute('data-c'); sp[i].style.color = lit && c ? c : ''; }
    }
  }
  if (hdr && hdr.classList.contains('can-over') && !intro && !byhero) hdr.classList.remove('over', 'can-over');
  var tk = false; addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(function () { tk = false; frame(); }); } }, { passive: true });
  addEventListener('resize', frame);
  frame();
})();

/* DYSTOPYE — ouverture logo-fenêtre fluide (transformations GPU uniquement) */
window.veilT = function (intro, base, e) {
var v = intro.__v;
if (!v) {
var veil = intro.querySelector('.veil');
if (!veil || !veil.querySelector('.vbox')) return;
v = intro.__v = { box: veil.querySelector('.vbox'), t: veil.querySelector('.vt'), b: veil.querySelector('.vb'), l: veil.querySelector('.vl'), r: veil.querySelector('.vr'), st: intro.querySelector('.stage'), f: 0, base: 0 };
}
var vw = innerWidth, vh = v.st.clientHeight || innerHeight, s = 1 + e * 55, f = vw < 700 ? 3 : 2;
if (v.f !== f || v.base !== base) { v.f = f; v.base = base; v.box.style.width = (base * f) + 'vw'; }
var W = base / 100 * vw * s, H = W * 873 / 5517, cx = vw / 2, cy = vh * .48;
v.box.style.transform = 'translate3d(-50%,-50%,0) scale(' + (s / f) + ')';
v.t.style.transform = 'translate3d(0,' + (cy - H / 2 - vh + 1) + 'px,0)';
v.b.style.transform = 'translate3d(0,' + (cy + H / 2 - 1) + 'px,0)';
v.l.style.transform = 'translate3d(' + (cx - W / 2 - vw + 1) + 'px,0,0)';
v.r.style.transform = 'translate3d(' + (cx + W / 2 - 1) + 'px,0,0)';
};
window.dispatchEvent(new Event('resize'));
/* intro v3 : structure + barre iPhone */
(function () {
var m = document.querySelector('meta[name=viewport]');
if (m && m.content.indexOf('viewport-fit') < 0) m.setAttribute('content', m.content + ',viewport-fit=cover');
var vs = document.querySelectorAll('.intro .veil');
for (var i = 0; i < vs.length; i++) { var v = vs[i]; if (v.querySelector('.vz')) continue; var z = document.createElement('div'); z.className = 'vz'; while (v.firstChild) z.appendChild(v.firstChild); v.appendChild(z); }
})();
window.veilT = function (intro, base, e) {
if (window.CSS && CSS.supports && CSS.supports('animation-timeline: view()')) return;
var z = intro.__z || (intro.__z = intro.querySelector('.vz'));
if (!z) return;
var f = innerWidth < 700 ? 3 : 2;
z.style.transform = 'translate(-50%,-50%) scale(' + ((1 + e * 55) / f) + ')';
};
window.dispatchEvent(new Event('resize'));
/* barre : se cache en descendant, revient en remontant (apres l'ouverture) */
(function () {
var h = document.getElementById('hdr'); if (!h) return;
var last = scrollY, tk = false;
function lim() { var i = document.querySelector('.intro'); return i ? i.offsetTop + i.offsetHeight : 80; }
function run() { tk = false; var y = scrollY, d = y - last; if (Math.abs(d) < 6) return; if (y > lim() && d > 0 && !document.body.style.overflow) h.classList.add('hide'); else if (d < 0 || y <= lim()) h.classList.remove('hide'); last = y; }
addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true });
})();
/* contact : confirmation d'envoi */
(function () {
var f = document.querySelector('form[action*="contact"]'); if (!f) return;
f.addEventListener('submit', function () { var b = f.querySelector('button'); if (b) { b.textContent = 'Envoi…'; b.style.opacity = '.6'; } });
var ok = f.querySelector('.ok');
if (ok || location.search.indexOf('contact_posted=true') > -1) {
setTimeout(function () { (ok || f).scrollIntoView({ block: 'center' }); var t = document.getElementById('toast'); if (t) { t.querySelector('span').innerHTML = 'Message envoyé ✓ On te répond très vite.'; t.classList.add('on'); setTimeout(function () { t.classList.remove('on'); }, 5000); } }, 300);
}
})();
